import React, { useCallback } from 'react';
import { styled } from '@linaria/react';
import { GLOBAL, CLIENTS } from 'constants/routes.js';
import { Button } from '@livecommerce/design-system';
import { useDispatch, useSelector } from 'react-redux';
import { css, cx } from '@linaria/core';
import { useHistory } from 'react-router-dom';
import { unsetMasqueradeMode as unsetMasqueradeModeAction } from 'actions/ui.js';
import { setOrUpdateOrgId as setOrUpdateOrgIdAction } from 'actions/session.js';
import { trackingService } from 'services/tracking/TrackingService.js';
import { useLocalization } from 'contexts/LocalizationContext.jsx';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const attachedToBottom = css`
  bottom: 0;
`;

const exitButton = css`
  pointer-events: auto;
`;

const masqueradeBannerContainer = css`
  background: rgba(255, 171, 0, 0.8);
  height: 64px;
  position: fixed;
  right: 0;
  left: 0;
  z-index: 10;
  pointer-events: none;
`;

const onTopOfNotification = css`
  bottom: 76px;
`;

const MasqueradeBanner = () => {
  const dispatch = useDispatch();
  const setOrUpdateOrgId = useCallback((payload) => dispatch(setOrUpdateOrgIdAction(payload)), [dispatch]);
  const unsetMasqueradeMode = useCallback(() => dispatch(unsetMasqueradeModeAction()), [dispatch]);
  const footer = useSelector((state) => state.notifications.footer);
  const masqueradeMode = useSelector((state) => state.ui.masqueradeMode);
  const history = useHistory();
  const { t } = useLocalization();
  if (!masqueradeMode) return null;

  const { title } = masqueradeMode.org || masqueradeMode.client || {};

  const exit = () => {
    trackingService.track({
      eventType: 'masquerade:exit',
    });
    const route = masqueradeMode.client ? CLIENTS : GLOBAL;
    unsetMasqueradeMode();
    setOrUpdateOrgId(null);
    history.push(route);
  };

  return (
    <div
      className={cx(
        masqueradeBannerContainer,
        footer ? onTopOfNotification : attachedToBottom,
      )}
    >
      <StyledContainer>
        {t('masqueradeBannerComponent.title')}: <strong>{title}</strong>
        <Button
          className={exitButton}
          id="masquerade-exit"
          variant="solidRed"
          iconName="cross"
          onClick={exit}
        >
          {t('masqueradeBannerComponent.exitButtonTitle')}
        </Button>
      </StyledContainer>
    </div>
  );
};

export default MasqueradeBanner;
